import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import BigNumber from 'bignumber.js';
import { sharePublishReplay } from 'ngx-libs';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { PaymasterMethod } from 'src/app/models/paymaster-method';
import { AccountService } from 'src/app/services/account.service';
import { ContractService } from 'src/app/services/contract.service';
import { EthWalletService } from 'src/app/services/eth-wallet.service';
import { MarketService } from 'src/app/services/market.service';
import { PaymasterService } from 'src/app/services/paymaster.service';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-paymaster',
  templateUrl: './paymaster.component.html',
  styleUrls: ['./paymaster.component.scss']
})
export class PaymasterComponent implements OnInit {
  @Input() method: (paymasterMethod?: PaymasterMethod) => Observable<BigNumber>;
  @Input() key: string;
  @Output() select = new EventEmitter();
  @Output() quoteGasUpdate = new EventEmitter();
  features = environment.features;
  item: Observable<any>;
  items: any[] = [];

  private lastItem: any = null;

  private lastQuoteGas = new BigNumber(0);

  constructor(
    public paymasterService: PaymasterService,
    private accountService: AccountService,
    private ethWalletService: EthWalletService,
    private contractService: ContractService,
    private marketService: MarketService
  ) {}

  ngOnInit(): void {
    this.items = this.paymasterService.createItems(this.method);

    this.item = this.paymasterService.key.pipe(
      map((key) => {
        const k = this.key || key;
        this.key = '';
        return this.items.find((i) => i.key === k) || this.items[0];
      }),
      tap((item) => this.selectItem(item)),
      sharePublishReplay(1)
    );

    this.item.pipe(
      switchMap((item) => item.quoteGas),
      untilDestroyed(this)
    ).subscribe((gas: any) => {
      this.updateQuoteGas(gas);
    });
  }

  onSelect(item: any) {
    this.paymasterService.select(item.key);
    this.selectItem(item);
  }

  private selectItem(item: any) {
    if (this.lastItem === item) {
      return;
    }
    this.lastItem = item;
    this.paymasterService.getMethod().subscribe(
      (method) => this.select.next(method)
    );
  }

  private updateQuoteGas(gas: BigNumber) {
    if (this.lastQuoteGas.eq(gas)) {
      return;
    }
    this.lastQuoteGas = gas;
    this.quoteGasUpdate.next(gas);
  }
}
